import axios from 'axios';
import _ from 'lodash';
import { push } from 'connected-react-router';
import { NETWORK } from '../../../../framework/App/AppConstants';
import { PAGE_NAME, SEPA_API, APPLICATION_STATUS} from '../../../config/DEConstants';
import { setServerData } from '../../../../framework/store/ServerData/ServerDataActions';
import { spinnerClose } from '../../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { trackTransition } from '../../../../framework/store/FPTI/FPTIActions';
import { buildCapeTxnRunner } from '../../../../framework/App/CapeTransaction';
const runDeSepaCapeTxn = buildCapeTxnRunner('de_sepa');

export const submitSepaApi = (data) => (dispatch, getState) => {
    return runDeSepaCapeTxn(() => {
        const state = getState();
        const { serverData = {} } = state;
        const { _csrf = '' } = serverData;

        return axios
            .request({
                url: SEPA_API,
                method: 'post',
                headers: {
                    ...NETWORK.REQUEST.XHR.HEADER,
                    'X-CSRF-Token': _csrf
                },
                data
            })
            .then(response => {
                dispatch(spinnerClose());
                dispatch(setServerData({
                    decisionModel: response.data,
                    invalidAddressMsg: _.get(response, 'data.showInvalidAddress'),
                    showValidationSoftDecline: _.get(response, 'data.showValidationSoftDecline')
                }));
                const appStatus = _.get(response, 'data.applicationStatus');
                window.capeLog && window.capeLog(`submitSepaApi:de:response: applicationStatus: ${appStatus}`);

                if (appStatus === APPLICATION_STATUS.PENDING) {
                    dispatch(push(PAGE_NAME.CONTRACT_PAGE));
                } else if (appStatus === APPLICATION_STATUS.VIEW_SEPA) {
                    dispatch(push(PAGE_NAME.SEPA_PAGE));
                } else if (appStatus === APPLICATION_STATUS.SOFT_DECLINE) {
                    dispatch(push(PAGE_NAME.APPLY_PAGE));
                } else if (appStatus === APPLICATION_STATUS.ANS_SOFT_DECLINE) {
                    const extra = {};
                    extra.ppc_status = appStatus;
                    dispatch(trackTransition('pp_credit_applypage', 'prepare_pp_credit_applypage', extra));
                    dispatch(push(PAGE_NAME.APPLY_PAGE));
                } else {
                    dispatch(push(PAGE_NAME.DECISION_PAGE));
                }
            })
            .catch(err => {
                window.capeLog && window.capeLog(`submitSepaApi:de:error: ${err}`);
                dispatch(spinnerClose());
                dispatch(push(PAGE_NAME.ERROR_PAGE));
            });
    });
};
